import api from "@/config/apiConfig"

class DashboardController {
  async getStats(params = {}) {
    try {
      const response = await api.get("/dashboard", { params });
      return response.data;
    } catch (error) {
      console.error("Erro no DashboardController.getStats: ", error);
      throw error;
    }
  }
}

export default new DashboardController();

